import { Controller } from "@hotwired/stimulus"
import * as THREE from "three"

export default class extends Controller {
  async connect() {
    console.log("🌍 GlobeController conectado");

    const globe = window.Globe()
      (this.element)
      .globeImageUrl("//unpkg.com/three-globe/example/img/earth-dark.jpg")
      .backgroundColor("#0A0A1E");

    // Material del globo
    globe.globeMaterial().color.set("#0a0a0a");
    globe.globeMaterial().transparent = true;
    globe.globeMaterial().opacity = 0.5;

    globe.pointOfView({ lat: 20, lng: -80, altitude: 2 });

    const controls = globe.controls();
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.5;
    controls.enableZoom = false;

    // ---- Cargar JSON ----
    const res = await fetch("https://cdn.rawgit.com/dataarts/webgl-globe/2d24ba30/globe/population909500.json");
    const rawData = await res.json();

    // ---- Geometría base y material (compartidos para todas las instancias) ----
    // La altura "1" es la altura base; la escalaremos por 'height' más adelante.
    const baseGeometry = new THREE.CylinderGeometry(0.001, 0.1, 1, 6, 1, true);
    const baseMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff99 });

    // Contar cuántos spikes vamos a crear (cada spike = 3 valores: lat,lng,mag)
    let totalSpikes = 0;
    rawData.forEach(country => { totalSpikes += Math.floor(country[1].length / 3); });
    totalSpikes = Math.max(1, Math.floor(totalSpikes));

    const instancedMesh = new THREE.InstancedMesh(baseGeometry, baseMaterial, totalSpikes);
    // útil si piensas animar luego
    instancedMesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
    globe.scene().add(instancedMesh);

    const dummy = new THREE.Object3D();
    const radius = globe.getGlobeRadius();

    // Vectores reutilizables para evitar allocations en el loop
    const pos = new THREE.Vector3();
    const normal = new THREE.Vector3();
    const up = new THREE.Vector3(0, 1, 0);
    const quat = new THREE.Quaternion();

    let i = 0;
    rawData.forEach(country => {
      const values = country[1];
      for (let j = 0; j < values.length; j += 3) {
        const lat = values[j];
        const lng = values[j + 1];
        const mag = values[j + 2];

        // Convertir lat/lng a spherical angles (phi, theta) compatibles con setFromSphericalCoords
        const phi = (90 - lat) * (Math.PI / 180);
        const theta = (lng) * (Math.PI / 180);

        // Magnitud -> altura (ajusta el factor a tu gusto)
        let height = (mag / 3) * 300;
        if (!isFinite(height) || height <= 0) height = 1; // seguridad
        height = Math.max(0.5, Math.min(height, 800)); // clamp para evitar extremos

        // posición en la superficie de la esfera (radio = radius)
        pos.setFromSphericalCoords(radius, phi, theta);

        // normal (direccion radial hacia afuera)
        normal.copy(pos).normalize();

        // Posicionamos el cilindro de modo que su base esté en la superficie:
        // como el cilindro está centrado en su origen y su altura = 1 (baseGeometry),
        // después de escalar en Y por 'height' debemos moverlo hacia afuera height/2
        dummy.position.copy(pos).add(normal.clone().multiplyScalar(height / 2 + 0.01)); // pequeño offset para evitar z-fighting

        // Escalamos en Y para obtener la altura deseada (baseGeometry height = 1)
        dummy.scale.set(1, height, 1);

        // Orientación: rotar el eje Y local (0,1,0) para que coincida con la normal
        quat.setFromUnitVectors(up, normal);
        dummy.quaternion.copy(quat);

        // Actualizar matriz y guardarla en la instancia
        dummy.updateMatrix();
        instancedMesh.setMatrixAt(i, dummy.matrix);

        i++;
        if (i >= totalSpikes) break; // seguridad por si el conteo fue distinto
      }
    });

    // Si creamos menos de totalSpikes, ajustamos el count real para evitar dibujar vacíos
    instancedMesh.count = i;
    instancedMesh.instanceMatrix.needsUpdate = true;

    console.log("Instancias creadas:", i);
  }
}
